import { Module } from 'vuex'
import axios from 'axios'
import { BASE_API_URL } from '@/config'

export interface Login {
  username: string
  password: string
}
export interface AuthStore {
  token: string | null
}

export const authStore: Module<AuthStore, {}> = {
  namespaced: true,
  state: () => ({
    token: null
  }),
  mutations: {
    removeToken(state) {
      state.token = null
    },
    addToken(state, payload: string) {
      state.token = payload
    }
  },
  actions: {
    async ping({ dispatch }) {
      try {
        await axios.get(`${BASE_API_URL}/auth/ping`)
      } catch {
        dispatch('logout')
      }
    },
    async login({ commit }, payload: Login) {
      const { data } = await axios.post(`${BASE_API_URL}/auth/login`, payload)
      commit('addToken', data.token)
      localStorage.setItem('token', data.token)
    },
    async attemptLocalToken({ commit, dispatch }) {
      const token = localStorage.getItem('token')
      commit('addToken', token)
      dispatch('ping')
    },
    async logout({ commit }) {
      localStorage.removeItem('token')
      commit('removeToken')
    }
  },
  getters: {
    token: state => state.token,
    authenticated: state => !!state.token
  }
}
